export const convertErrorsArrayToString = (errors) =>
  errors.reduce((actual, current) => `${actual}\n${current.message}`, '');
